import styles from "./NewCase.module.css";
import DateBar from "../../components/DateBar/DateBar";
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import { useTranslation } from "react-i18next";
import { addCaseData } from "../../backend/DataManager";
import { format } from "date-fns";
import { toast, ToastContainer } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";

function NewCase() {
	const { t } = useTranslation(["new-case", "dashboard"]);

	const handleButtonClick = async () => {
		const caseNumber = document.getElementById("case_number_input").value.toUpperCase();
		const caseStatus = document.getElementById("case_status_input").value;
		const appoDate = document.getElementById("appo_date_input").value;
		const cardNumber = document.getElementById("card_number_input").value;
		const birthDate = document.getElementById("birth_date_input").value;

		if (caseNumber === "" || cardNumber === "" || birthDate === "" || appoDate === "" || caseStatus === "") {
			toast.error(t("dashboard:msg_field_empty"));
			return;
		}

		const inputDataMap = {
			caseNumber: caseNumber,
			caseStatus: caseStatus,
			appoDate: appoDate,
			cardNumber: cardNumber,
			birthDate: birthDate,
			registrationDate: format(new Date(), "dd-MM-yyyy")
		};

		try {
			addCaseData(inputDataMap);
			toast.success(t("msg_case_added"));
		} catch (error) {
			toast.error(t("msg_case_not_added"));
		}
	};

	return (
		<div>
			<DateBar />
			<Header />

			<div className={styles.new_case_container}>
				<h1>{t("case_title")}</h1>

				<div className={styles.input_container}>
					<label>{t("dashboard:dashboard_case_number")}</label>
					<input
						id="case_number_input"
						className={styles.input_field}
						type="text"
					/>
				</div>
				<div className={styles.input_container}>
					<label>{t("case_status")}</label>
					<textarea
						id="case_status_input"
						className={styles.input_field}
						type="text"
					/>
				</div>
				<div className={styles.input_container}>
					<label>{t("case_appo_date")}</label>
					<input
						id="appo_date_input"
						className={styles.input_field}
						type="text"
					/>
				</div>
				<div className={styles.input_container}>
					<label>{t("dashboard:dashboard_card_number")}</label>
					<input
						id="card_number_input"
						className={styles.input_field}
						type="text"
					/>
				</div>
				<div className={styles.input_container}>
					<label>{t("dashboard:dashboard_birth_date")}</label>
					<input
						id="birth_date_input"
						className={styles.input_field}
						type="text"
					/>
				</div>

				<button
					onClick={() => handleButtonClick()}
					className={styles.search_button}>
					{t("case_add_btn")}
				</button>
			</div>
			<Footer />
			<ToastContainer />
		</div>
	);
}

export default NewCase;
